var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"blue-bg"},[_c('section',{staticClass:"container"},[_c('h1',{staticClass:"text-center"},[_vm._v("\n      "+_vm._s(_vm.$t("Checkout complete"))+"\n    ")]),_vm._v(" "),_c('div',[_vm._v("\n      "+_vm._s(_vm.$t(
          "Thanks for your purchase! You'll receive an email confirmation shortly.",
        ))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }